import { TranslateService } from '@ngx-translate/core';
import { LocalService } from './local.service';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
import * as i2 from "./local.service";
var LanguageService = /** @class */ (function () {
    function LanguageService(translate, localService) {
        this.translate = translate;
        this.localService = localService;
        var language = this.localService.getJsonValue('language');
        if (!language) {
            language = navigator.language.split('-')[0];
        }
        this.setLanguage(language);
    }
    LanguageService.prototype.setLanguage = function (language) {
        this.selectedLanguage = language;
        this.localService.setJsonValue('language', language);
        this.translate.use(language);
    };
    LanguageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LanguageService_Factory() { return new LanguageService(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.LocalService)); }, token: LanguageService, providedIn: "root" });
    return LanguageService;
}());
export { LanguageService };
